import React, { useEffect, useRef } from 'react';
import { Ring } from '@uiball/loaders';
import { BG_DARK } from '@etiquette-ui/colors';
import styled from 'styled-components';
import { useCameraStream } from '../../../hooks/useCameraStream';

const LoaderContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 30px 0;
`;

const StyledVideo = styled.video`
  width: 100%;
  height: auto;
  object-fit: cover;
`;

interface Props {
  streamURL: string;
  muted: boolean;
  setWithAudio: (v: boolean) => void;
  setStreamReady: (v: boolean) => void;
  setMuted: (v: boolean) => void;
  onSignatureExpired?: () => void;
}

const VideoUI: React.FC<Props> = ({
  streamURL,
  muted,
  setWithAudio,
  setStreamReady,
  setMuted,
  onSignatureExpired,
}) => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const { play, destroy, ready, hasAudio } = useCameraStream(videoRef, {
    onSignatureExpired,
  });

  useEffect(() => {
    play(streamURL).catch(console.error);

    return () => {
      destroy();
      setStreamReady(false);
      setWithAudio(false);
      setMuted(true);
    };
  }, [streamURL]);

  useEffect(() => {
    setStreamReady(ready);
  }, [ready]);

  useEffect(() => {
    setWithAudio(hasAudio);
  }, [hasAudio]);

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.muted = muted;
    }
  }, [muted]);

  return (
    <>
      <StyledVideo
        ref={videoRef}
        controls={false}
        autoPlay
        muted={muted}
        playsInline
        style={{ display: ready ? 'block' : 'none' }}
      />
      {!ready && (
        <LoaderContainer>
          <Ring color={BG_DARK} size={22} />
        </LoaderContainer>
      )}
    </>
  );
};

export default VideoUI;